import { spacing } from 'ext-ui/style/spacing'
import styleVars from 'src/style/variables.json'

export const policyStatusHeaderMenuSpaceSx = {
  '.MuiDataGrid-columnHeader.policy-status-header': {
    paddingRight: 0,
  },
  '.MuiDataGrid-columnHeader.policy-status-header .MuiDataGrid-columnHeaderTitleContainerContent > div':
    {
      gap: spacing(1),
    },
  '.MuiDataGrid-columnHeader.policy-status-header .headerName': {
    flex: '0 0 auto',
    overflow: 'visible',
    whiteSpace: 'nowrap',
  },
  '.MuiDataGrid-columnHeader.policy-status-header .headerDescriptionTooltip': {
    flex: `0 0 ${spacing(3)}`,
    overflow: 'visible',
  },
  '.MuiDataGrid-columnHeader.policy-status-header .headerDescriptionTooltip svg':
    {
      height: spacing(3),
      width: spacing(3),
    },
  '.MuiDataGrid-columnHeader.policy-status-header .MuiDataGrid-menuIcon, .MuiDataGrid-columnHeader.policy-status-header:hover .MuiDataGrid-menuIcon':
    {
      flex: `0 0 ${spacing(6)}`,
      marginRight: `-${spacing(2)}`,
      width: spacing(6),
    },
}

const cellUnits = {
  'table-cell-h-padding': styleVars.units['base-unit-4'],
  'table-cell-v-padding': styleVars.units['base-unit-4'],
  'table-header-footer-cell-v-padding': styleVars.units['base-unit-3'],
  'table-cell-h-gap': styleVars.units['base-unit-2'],
  'table-cell-v-gap': styleVars.units['base-unit-1'],
  'table-border-radius': styleVars.units['base-unit-3'],
}

export default cellUnits
